import React from "react";
import OverallScore from "./OverallScore";
import PerPromptScores from "./PerPromptScores";
import ExportButton from "./ExportButton";
import "./review-score.css";

const ReviewScore = ({ queryScores, contentDraft, isLoading }) => {
  return (
    <div
      style={{
        backgroundColor: "var(--bg-surface)",
        borderTop: "1px solid var(--border)",
        opacity: isLoading?.rescore ? 0.5 : 1,
        transition: "opacity 0.3s ease",
      }}
      className="px-4 py-4 review-score-root"
      data-testid="review-score"
    >
      <div className="d-flex justify-content-end mb-3">
        <button
          type="button"
          className="btn btn-outline-info text-dark d-flex align-items-center gap-2 px-3 py-1.5"
          style={{ fontSize: "13px", borderRadius: "20px" }}
          onClick={() => {
            if (typeof window.triggerElelemAssistantPrompt === "function") {
              window.triggerElelemAssistantPrompt(
                "Grade my webpage copy draft to find semantic gaps.",
              );
            }
          }}
        >
          <i className="bi bi-sparkles text-info"></i> Grade webpage copy with
          elelem Assistant
        </button>
      </div>
      <OverallScore queryScores={queryScores} />
      <PerPromptScores queryScores={queryScores} />
      <ExportButton contentDraft={contentDraft} />
    </div>
  );
};

export default ReviewScore;
